<template>
  <div class="cooperation">
    <heads></heads>
    <div class="container">
      <div
        class="container-top"
        v-if="bannerArray"
        :style="{ '--background': 'url(' +'\''+ bannerArray.path +'\''+ ')' }"
      ></div>
      <div class="container-bottom">
        <div class="cooperation-item">
          <div class="title"><span class="require">合作类型:</span></div>
          <div class="content">
            <el-radio-group v-model="form.cooperationType" @change="changeCooperationType">
              <el-radio label="个人">个人</el-radio>
              <el-radio label="公司">公司</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="cooperation-item">
          <div class="title"><span class="require">业务类型:</span></div>
          <div class="content">
            <el-radio-group v-model="form.serviceType" @change="changeServiceType">
              <el-radio v-for="(item, index) in serviceTypeList"
              :key="index" :label="item">{{item}}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="cooperation-item" v-if="isOther">
          <div class="title title2"></div>
          <div class="content">
            <el-input
              type="textarea"
              v-model="serviceTypeDescription"
              placeholder="请输入你可以提供的服务"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="cooperation-item">
          <div class="title title2"><span class="require">联系人:</span></div>
          <div class="content">
            <el-input
              v-model="form.contact"
              placeholder="联系人"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="cooperation-item" v-if="isCompany">
          <div class="title title2"><span>公司:</span></div>
          <div class="content">
            <el-input
              v-model="form.company"
              placeholder="公司"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="cooperation-item">
          <div class="title title2"><span class="require">联系电话:</span></div>
          <div class="content">
            <el-input
              v-model="form.mobile"
              placeholder="11位手机号码"
              style="display: inline"
            ></el-input>
          </div>
        </div>
        <div class="cooperation-item">
          <div class="title title2"><span class="require">验证码:</span></div>
          <div class="content">
            <div class="sendCode">
              <el-input
                v-model="form.verificationCode"
                placeholder="4位验证码"
                style="display: inline"
              ></el-input>
              <span :class="isPhoneNumber(form.mobile) ? 'active-txt2' : ''"
                @click="sendSMS"
                >{{ smsCodeTime != 0 ? smsCodeTime : "短信验证" }}</span>
            </div>
          </div>
        </div>
        <div class="cooperation-item">
          <div class="title title2"><span>备注:</span></div>
          <div class="content">
            <el-input
              type="textarea"
              v-model="form.description"
              placeholder="您可以在此补充一些需要告诉我们的消息"
            ></el-input>
          </div>
        </div>
        <div class="cooperation-last-item">
          <div @click="submit">提交基本消息</div>
        </div>
      </div>
    </div>
    <homeFoots></homeFoots>
   <quickContact :message="quickContactMessage"></quickContact>
    <!-- <foots></foots> -->
  </div>
  <!-- articalDetail end -->
</template>

<script>
import heads from "@/components/comment/heads.vue";
import banners from "@/components/comment/banners.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import axios from "axios";
import { handlePicPlusPre,isPhoneNumber } from "@/util/util.js";
import qs from "qs";
import wxShare from "@/common/wx_share.js";
export default {
  name: "articalDetail",
  data() {
    return {
      content: "",
      loading: false,
      // 短信重发时间
      smsCodeTime:0,
      serviceTypeList: [
        "酒店/宾馆",
        "农家院",
        "基地",
        "特色场地",
        "拓展老师/教练/培训师",
        "领队/导游",
        "租车/大巴车",
        "景区/景点",
        "摄影/摄像",
        "道具租赁",
        "印刷制作",
        "搭建/策划",
        "培训机构",
        "旅行社",
        "活动执行",
        "其他(备注)",
      ],
      cooperationType: "个人",
      isCompany:false,
      isOther:false,
      serviceTypeDescription:"",
      // 提交表单
      form: {
        serviceType: "酒店/宾馆",
        cooperationType: "个人",
        contact: "",
        mobile: "",
        company: "",
        wxNumber: "",
        description: "",
      },
      bannerArray: [
        { path: "ak.jpg" },
      ],
      quickContactMessage:{
        type:1
      },
    };
  },
  components: {
    heads,
    banners,
    homeFoots,
    quickContact,
  },
  computed: {
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
  },
  methods: {
    handlePicPlusPre,
    isPhoneNumber,
    // 改变合作身份
    changeCooperationType(){
      if(this.form.cooperationType=="公司"){
        this.isCompany = true;
      }else{
        this.isCompany = false;
      }
    },
    // 改变业务
    changeServiceType(){
      if(this.form.serviceType=="其他(备注)"){
        this.isOther = true;
      }else{
        this.isOther = false;
      }
    },
    // 获取广告
    getBanner() {
      const params = {
        positionId: 17,
        cityId:this.getLocationSiteCityId
      };
      axios
        .get(`/api/adm/list`, {
          params,
        })
        .then((res) => {
          // console.log(res)
          if(res.data &&res.data.code == 200){
            if (res.data.adList) {
              this.bannerArray = res.data.adList;
              if (this.bannerArray && this.bannerArray.length>0) {
                this.bannerArray.forEach((banner) => {
                  if (banner.path) {
                    banner.path = this.handlePicPlusPre(banner.path);
                  } else {
                    banner.path = "ak.jpg";
                  }
                  banner.path = banner.path[0];
                });
                console.log(this.bannerArray)
                this.bannerArray = this.bannerArray[0];
              }else{
                this.bannerArray.path = "ak.jpg";
              }
              console.log(this.bannerArray)
            }
          }
        });
    },

    clearForm(){
      // 提交表单
      this.form = {
        serviceType: "酒店/宾馆",
        cooperationType: "个人",
        contact: "",
        mobile: "",
        company: "",
        wxNumber: "",
        description: "",
      },
      this.serviceTypeDescription = null;
    },
     // 发送短信
    sendSMS() {
      if(this.smsCodeTime>0 || !isPhoneNumber(this.form.mobile)){
        return;
      }
      let params = { mobile: this.form.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 短信计时器
    smsDown() {
      setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
      }, 1000);
    },
    // 提交表单
    submit() {
      let { contact, mobile, verificationCode } = this.form;
      console.log(!mobile || mobile.length != 11);
      console.log(!verificationCode);
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!contact) {
        this.$message({
          message: "请填写联系人",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      // 如果是个人清空公司
      if(this.form.cooperationType=="个人"){
        this.form.company = ""
      }
      // 如果是其他，将备注信息赋予业务类型
      if(this.form.serviceType=="其他(备注)"){
        this.form.serviceType = this.serviceTypeDescription
      }
      let params = this.form;
      axios
        .post(`/api/cooperation/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
               if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "基本信息提交成功";
                }
                this.$message({
                  message: msg,
                  type: "success",
                  center: true,
                });
                this.clearForm();
            } else {
              if (res.data.code == 500) {
                
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "基本信息提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
  },
  mounted() {
    this.getBanner();
    this.loading = true;
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}
.container-top {
  background: #f8f8f8;
  background-repeat: no-repeat;
  /* background-position-x: center; */
  background-size: cover;
  background-image: var(--background);
  /* background-image: url(var(--background)); */
  /* background-size: 1920px 350px; */
  height: 350px;
}
.container-bottom {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  /* width: 1060px; */
  width: 960px;
  position: relative;
  margin: 0 auto;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.container-bottom .cooperation-item {
  display: flex;
  flex-direction: row;
  margin: 10px 10px;
}
.container-bottom .cooperation-item .title {
  flex: 1;
}
.container-bottom .cooperation-item .title2 {
  line-height: 35px;
}
.container-bottom .cooperation-item .content {
  display: flex;
  flex-direction: row;
  flex: 8;
  flex-wrap: wrap;
}
/* .container-bottom .cooperation-item .content>>>.el-radio__label{
  font-size: 16px;
    color: #222;
    padding: 0 10px;
    font-weight: 700;
    width: 180px;
} */
.container-bottom .cooperation-item .content >>> .el-radio__inner {
  width: 20px;
  height: 20px;
}
.container-bottom .cooperation-item .content >>> .el-radio__inner::after {
  width: 6px;
  height: 6px;
}
.container-bottom .cooperation-item .content >>> .el-radio__label {
  font-size: 16px;
  color: #222;
  padding: 0 10px;
  font-weight: 700;
  width: 170px;
  padding: 0px 0px 20px 10px;
  display: inline-block;
}
.cooperation-item .title span {
  width: 90px;
  font-size: 16px;
  font-weight: 700;
  color: #222;
  line-height: 20px;
  height: 20px;
  display: inline-block;

  text-align: right;
}
.cooperation-item .require::before {
  content: "*";
  color: #f00;
  font-size: 14px;
  padding-right: 5px;
}

/* el-select 样式 */
.cooperation-item >>> .el-input__inner {
  /* border: none; 
    border-color: transparent ;
    
    color:#000;
    font-weight: 700; */
  background: #f8f8f8;
  border: none;
  width: 340px;
}
.cooperation-item >>> .el-textarea__inner {
  background: #f8f8f8;
  width: 100%;
  border: none;
  min-height: 100px !important;
}
.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  width: 340px;
  background: #f8f8f8;
  border-radius: 6px;
}
.cooperation-item .sendCode >>> .el-input__inner {
  background: #f8f8f8;
  border: none;
  width: 260px;
}
.sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161, 0.2);
  cursor: pointer;
  width: 80px;
}
.sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: rgba(23, 211, 161);
  cursor: pointer;
  width: 80px;
}

.cooperation-last-item {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  position: relative;
  margin: 40px 0px;
}
.cooperation-last-item div {
  width: 340px;
  position: absolute;
  left: 110px;
  line-height: 50px;
  outline: none;
  background: none;
  border: none;
  height: 50px;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background-color: #222;
  border-radius: 6px;
  text-align: center;
}
.content>>>.el-radio-button__inner, .el-radio-group{
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 120%;
}
.content>>>.el-radio{
  margin-left: 5px;
}
</style>
<style>
/* @media screen and (max-width: 767px) {
  .el-dialog {
    width: 80% !important;
  }
} @media only screen and (max-width: 767px) */
</style>




// WEBPACK FOOTER //
// src/components/cooperation.vue